// '//host' — protocol-relative адрес чужого хоста, не внутренний путь
export const isInternalPath = (path: unknown): path is string =>
  typeof path === 'string' && path.startsWith('/') && !path.startsWith('//')
